<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Client Templates'"
          :subTitleText="'In order to properly implement these templates, please consult with a Project Spectrum Cyber Advisor to determine which documents are needed.<br><br>To connect with a Project Spectrum Cyber Advisor, please use the Help Desk feature located in the bottom right corner of the Project Spectrum website.'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Client Templates Section Start -->
    <section class="p-0">
      <div id="top-container" class="container-fluid px-xs-1 px-md-5">
        <b-row>
          <b-col lg="4" xl="3" cols="12">
          </b-col>
          <b-col lg="8" xl="9" cols="12">
            <p class="paragraph-text m-0">Select up to 6 templates to download at a time</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" xl="3" cols="12">
            <div class="p-3 px-4 mb-2 mb-4 search-and-filter">
              <!-- Search by Template Title -->
              <b-form-group class="search-and-filter-title">
                <label>Search by Title</label>
                <b-form-input
                  v-model="searchTitle"
                  placeholder="Type and enter to search"
                  trim
                ></b-form-input>
              </b-form-group>

              <!-- Search by Catagory -->
              <b-form-group class="search-and-filter-title">
                <label>Categories:</label>
                <b-form-select
                  v-model="searchCategory"
                  :options="optionsCategories"
                ></b-form-select>
              </b-form-group>

              <!-- Search by Level -->
              <b-form-group class="search-and-filter-title">
                <label>Levels:</label>
                <b-form-select
                  v-model="searchLevel"
                  :options="optionsLevels"
                ></b-form-select>
              </b-form-group>

              <!-- Displayed selected templates for download -->
              <div v-if="downloadArray.length > 0" class="w-100">
                <b-form-group class="search-and-filter-title">
                  <label>{{ `Selected Templates: (${downloadArray.length})` }}</label>
                  <ul class="m-0">
                    <li class="selected-template-item mb-2" v-for="item in selectedTemplates" :key="item.id">
                      <v-row>
                        <v-col cols="2" class="pr-0 pb-0">
                          <div class="remove-template-item" @click="() => selectTemplateItem(item.id)">&times;</div>
                        </v-col>
                        <v-col cols="10" class="pr-0 pb-0">
                          <div>{{ item.title }}</div>
                        </v-col>
                      </v-row>
                    </li>
                  </ul>
                </b-form-group>

                <b-form-group class="d-flex justify-content-center">
                  <b-button
                      id="input-1"
                      key=""
                      class="modal-btn"
                      size="sm"
                      :disabled="downloadArray.length < 1"
                      @click="downloadSelectedTemplates"
                  >Downlaod Checked</b-button>
                </b-form-group>
                <b-form-group class="d-flex justify-content-center">
                  <b-button
                    id="input-2"
                    key=""
                    class="modal-btn"
                    size="sm"
                    @click="clearSelectedTemplates"
                  >Clear All</b-button>
                </b-form-group>
              </div>
            </div>
          </b-col>
          <b-col lg="8" xl="9" cols="12">
            <p class="d-flex d-sm-none paragraph-small-screen-text">Swipe left to view preview button</p>
            <b-table
              v-if="itemsFromSearchQuery.length > 0"
              :fields="fields"
              :items="itemsFromSearchQuery"
              thead-class="table-header"
              tbody-class="table-body"
              responsive
              outlined
              hover
              sticky-header
              sort-icon-left
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <!-- Table Template Checkbox Column -->
              <template #cell(compare)="data">
                <div class="d-flex flex-row justify-content-center">
                  <b-form-checkbox
                    size="lg"
                    v-model="form.checkbox[data.item.id]"
                    @change="() => selectTemplateItem(data.item.id)"
                    :checked="downloadArray.includes(data.item.id)"
                    :value="true"
                    :unchecked-value="false"
                  />
                </div>
              </template>

              <!-- Table Template Templates Title Column -->
              <template #cell(title)="data">
                <div class="template-title">
                  <p class="clipped-text m-0" :title="data.item.title" :style="{ color: (failedDownloads.length > 0) && downloadArray.includes(data.item.id) ? 'red' : '#272727' }">
                    {{ data.item.title }}
                  </p>
                  <p v-if="(failedDownloads.length > 0) && downloadArray.includes(data.item.id)" style="color: red">
                    Failed To Download
                    &nbsp;
                    <font-awesome-icon
                      size="lg"
                      :icon="['fas', 'times-circle']"
                    />
                  </p>
                </div>
              </template>

              <!-- Table Template Templates Level Column -->
              <template #cell(level)="data">
                <div class="template-level">
                  <span>{{ optionsLevels.find(({ value }) => value === data.item.level)?.text }}</span>
                </div>
              </template>

              <!-- Table Templated Preview Button -->
              <template #cell(preview)="data">
                <div class="d-flex justify-content-center">
                  <router-link
                    :to="{ 
                      name: 'client-template-item', 
                      query: { templateId: data.item.id }, 
                    }"
                  >
                    <b-button 
                      class="btn-more" 
                      size="lg"
                    >
                      Preview
                    </b-button>
                  </router-link>
                </div>
              </template>

            </b-table>
            <div v-else class="empty-items w-100 d-flex flex-row justify-content-center align-items-center text-center">
              <span v-if="searchLevel !== 'level 1'">{{ `${searchLevel[0].toUpperCase()}${searchLevel.slice(1).toLowerCase()} templates will soon be available` }}</span>
              <span v-else>There are no Templates available for the search query.</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
    <!-- Client Templates Section End -->

    <!-- Start Modal for Deselecting All Templates -->
    <ModalWidget
      id="modal-template-issues"
      title="Selected Templates Limit Reached"
      centered
      hideFooter
    >
      <p slot="body" class="modal-paragraph text-center px-5">
        User Cannot select more than 6 templates
      </p>
      <b-button
        slot="row-buttons"
        id="input-3"
        key=""
        class="modal-btn"
        size="sm"
        @click="clearSelectedTemplates"
        >Deselect All
      </b-button>
    </ModalWidget>
    <!-- End Modal for Deselecting All Templates -->

    <!-- Start Modal for Displaying Download Statuses -->
    <ModalWidget
      id="template-download-statuses"
      title="Templates Downloaded"
      centered
      hideFooter
      :hideHeaderClose="isTemplatesDownloading"
      :noCloseOnBackdrop="isTemplatesDownloading"
      :closeHandler="closeModal"
    >
      <div slot="body" class="px-3 pb-3">
        <p v-if="isTemplatesDownloading" class="modal-paragraph text-left" style="color: yellow;">
          Template document download is now in progress...
        </p>
        <div v-if="successfullDownloads.length > 0">
          <p class="modal-paragraph text-left mb-1">
            The following templates were downloaded successfully:
          </p>
          <ul class="w-100 m-0 mb-1">
            <li 
              class="listitem-filename" 
              style="color: green;" 
              v-for="filename in successfullDownloads" 
              :key="filename"
            >
              <font-awesome-icon
                size="lg"
                :icon="['fas', 'check-circle']" 
              />
              &nbsp;
              {{ filename }}
            </li>
          </ul>
        </div>
        <div v-if="failedDownloads.length > 0">
          <p class="modal-paragraph text-left mt-1">
            The following templates failed to download:
          </p>
          <ul class="w-100 m-0 mt-1">
            <li 
              class="listitem-filename" 
              style="color: red" 
              v-for="filename in failedDownloads" 
              :key="filename"
            >
              <font-awesome-icon
                size="lg"
                :icon="['fas', 'times-circle']"
              />
              &nbsp;
              {{ filename }}
            </li>
          </ul>
        </div>
      </div>
      <b-button
        slot="row-buttons"
        id="input-3"
        key=""
        class="modal-btn"
        size="sm"
        :disabled="isTemplatesDownloading"
        @click="closeModal"
        >OK
      </b-button>
    </ModalWidget>
    <!-- End Modal for Displaying Download Statuses -->
  </div>
</template>

<script>
  import { BFormInput } from 'bootstrap-vue';
  import PageHeader from '../library/widgets/page-header.vue';
  import PageHeaderTitleContent from '../library/widgets/page-header-title-content.vue';
  import TitleTextContent from '../library/widgets/title-text-content.vue';
  import clientTemplatesData from '../../utils/clientTemplatesData';
  import ModalWidget from '../library/widgets/modal-widget.vue';
  import { EventBus } from '../../utils/eventBus';

  export default {
    name: 'clent-templates',
    components: {
      BFormInput, 
      PageHeader,
      PageHeaderTitleContent,
      TitleTextContent,
      ModalWidget,
    },
    data(){
      return {
        items: clientTemplatesData,
        searchTitle: null,
        searchCategory: null,
        searchLevel: null,
        optionsCategories: [],
        optionsLevels: [],
        downloadArray: [],
        sortBy: 'title',
        sortDesc: false,
        fieldsItems: [
          {
            key: 'compare',
            label: ' ',
            tdClass: 'align-middle',
          },
          {
            key: 'title',
            label: 'Template Title',
            tdClass: 'align-middle',
            sortable: true,
          },
          {
            key: 'category',
            label: 'Category',
            tdClass: 'align-middle',
            sortable: true,
          },
          {
            key: 'level',
            label: 'Level',
            tdClass: 'align-middle',
            sortable: true,
          },
          {
            key: 'preview',
            label: 'Details',
            thClass: 'text-center',
            tdClass: 'align-middle',
          },
        ],
        form: {
          checkbox: {},
        },
        successfullDownloads: [],
        failedDownloads: [],
      };
    },
    mounted() {
      this.init();
    },
    computed: {
      fields() {
        const levelsList = [ 
          ...new Set(
            this.itemsFromSearchQuery
              .filter(({ category }) => category === this.searchCategory)
              .map(({ level }) => level)
            )
        ];

        const categoriesList = [
          ...new Set(
            this.itemsFromSearchQuery
              .map(({ category }) => category)
          )
        ];

        this.fieldsItems[2].sortable = categoriesList.length > 1;
        this.fieldsItems[3].sortable = !this.searchLevel && levelsList.length === 0;

        return this.fieldsItems;
      },
      itemsFromSearchQuery() {
        let searchedItems = this.items;

        // Filter templates by template title
        if(this.searchTitle) {
          searchedItems = searchedItems.filter(({ title }) => {
            return this.searchTitle
                        .toLowerCase()
                        .split(' ')
                        .every(
                          (v) => title.toLowerCase().includes(v)
                        );
          });
        }

        // Filter templates by template category
        if(this.searchCategory) {
          searchedItems = this.searchCategory
                            ? searchedItems.filter(({ category }) => category === this.searchCategory)
                            : this.items;
        }

        // Filter templates by templated level
        if(this.searchLevel) {
          searchedItems = this.searchLevel
                            ? searchedItems.filter(({ level }) => level === this.searchLevel)
                            : this.items;
        }

        return searchedItems;
      },

      selectedTemplates() {
        return this.downloadArray.map(templateId => {
          const { id, title } = this.items.find(({ id }) => templateId === id);
          return { id, title };
        });
      },

      isTemplatesDownloading() {
        return this.successfullDownloads.length === 0 && this.failedDownloads.length === 0;
      }
    },
    methods: {
      init() {
        EventBus.$emit("activate-indicated-menu-item", "Info Hub");

        const categories = [
          ...new Set(this.items.map(({ category }) => category))
        ].map((category) => ({ value: category, text: category }));

        this.optionsCategories = [
          { value: null, text: 'Search Category' },
          ...categories,
        ];

        this.optionsLevels = [
          { value: null, text: 'Search Level' },
          { value: 'level 1', text: 'Level 1' },
          { value: 'level 2', text: 'Level 2' },
          { value: 'level 3', text: 'Level 3' },
        ];
      },
      selectTemplateItem(id) {
        if(this.downloadArray.includes(id)) {
          this.downloadArray = this.downloadArray.filter(templateId => templateId != id);
          this.$set(this.form.checkbox, id, false);

          if(this.failedDownloads.length > 0) {
            const { downloadFilename } = this.items.find((template) => template.id === id);
            this.failedDownloads = this.failedDownloads.filter((filename) => filename !== downloadFilename);
          }
        }
        else {
          this.downloadArray = [ ...this.downloadArray, id ];

          if((this.downloadArray.length <= 6) && (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)) {
            document
              .getElementById("top-container")
              .scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        if(this.downloadArray.length > 6) {
          this.downloadArray = this.downloadArray.slice(0, -1);
          this.$set(this.form.checkbox, id, false);
          this.$bvModal.show('modal-template-issues');
        }
      },
      async downloadSelectedTemplates() {
        this.$bvModal.show('template-download-statuses');

        try {
          // Get each docUrl and downloadFilename of the selected templates.
          const selectedTemplateItems = this.items
                                              .filter(({ id }) => this.downloadArray.includes(id))
                                              .map(({ docUrl, downloadFilename }) => ({ docUrl, downloadFilename }));

          const asyncTemplatesDownload = selectedTemplateItems.map(async ({ docUrl, downloadFilename }) => await this.downloadUrl(docUrl, downloadFilename));

          // Get the template documents that were successfully downloaded.
          const templateDownloadResponse = (await Promise.allSettled(asyncTemplatesDownload)).filter(({ status }) => status === 'fulfilled');

          if(templateDownloadResponse.length > 0) {
            // These are the template documents successfully downloaded.
            this.successfullDownloads = templateDownloadResponse.map(({ value }) => value);

            // Theses are the template documents that failed to be downloaded.
            this.failedDownloads = selectedTemplateItems
                                    .filter(({ downloadFilename }) => !this.successfullDownloads.includes(downloadFilename))
                                    .map(({ downloadFilename }) => downloadFilename);

            const fullfilledDownloadIds = this.successfullDownloads
                                          .map((fulfilledDownload) => this.items.find(({ downloadFilename }) => downloadFilename === fulfilledDownload).id);

            // Uncheck the templates on the table that were successfully downloaded.
            fullfilledDownloadIds.forEach((id) => {
              this.downloadArray = this.downloadArray.filter((templateId) => templateId !== id);
              this.$set(this.form.checkbox, id, false);
            });
          }
          else {
            // These are all the failed downloads with no successful download.
            this.failedDownloads = selectedTemplateItems.map(({ downloadFilename }) => downloadFilename);
          }
        }
        catch(error) {
          console.error(error.message);
        }
      },
      closeModal() {
        this.$bvModal.hide('template-download-statuses');
        this.successfullDownloads = [];
      },
      clearSelectedTemplates() {
        this.downloadArray = [];
        this.form.checkbox = {};
        this.failedDownloads = [];
        this.$bvModal.hide('modal-template-issues');
      }
    }
  }
</script>

<style scoped>
  .paragraph-text {
    color: #000;
    font-family: Rajdhani;
    font-size: clamp(22px, 2vw, 28px);
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
  }

  .paragraph-small-screen-text {
    color: #000;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: italic;
    font-weight: 500;
    line-height: 24px; 
  }

  .btn-more {
    width: 138px;
    height: 44px;
    padding: 10px 20px;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    background-color: #424EC4;
  }

  .template-title {
    max-width: 250px;
  }

  .template-level {
    width: 90px;
  }

  .clipped-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  #top-container {
    margin-top: 60px;
  }

  .search-and-filter {
    border-radius: 10px;
    background: #D5D7D7;
    min-width: 250px;
  }

  .search-and-filter-title label, .modal-paragraph {
    color: #272727;
    font-family: Rajdhani;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
    margin-bottom: 5px;
  }

  ul .listitem-filename {
    list-style-type: none;
  }

  .listitem-filename {
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }

  .selected-template-item {
    color: #272727;
    font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    list-style-type: none;
  }

  .remove-template-item {
    color: #424EC4;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 23px;
    cursor: pointer;
    width: 30px;
  }

  .modal-btn {
    width: 220px;
    height: 44px;
    padding: 10px 0px;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    border-radius: 50px;
    background-color: #424EC4;
  }

  .form-control {
    height: auto;
  }

  .empty-items {
    height: 200px; 
    font-size: clamp(18px, 2vw, 28px); 
    font-weight: 600;
  }

  :deep .b-table-sticky-header {
    border: 2px solid #000000;
    height: auto;
    max-height: 460px !important;
  }

  :deep .b-table-sticky-header th.table-b-table-default.position-relative, 
  :deep .b-table-sticky-header th.table-b-table-default {
    background-color: #D5D7D7 !important;
  }

  :deep .b-table-sticky-header .table-header {
    border-bottom: 2px solid #000000;
  }

  :deep .b-table-sticky-header > .table.b-table > thead > tr > th {
    position: sticky !important;
    top: -1px;
  }

  :deep table th {
    border-bottom: 0;
  }
</style>